/**
 * @generated SignedSource<<1ae7122bd95df6b0beb3513a1738e8ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type CreateTagMutationInput = {
  clientMutationId?: string | null;
  color: Colors;
  label: string;
};
export type TagModalCreateTagMutation$variables = {
  input: CreateTagMutationInput;
};
export type TagModalCreateTagMutation$data = {
  readonly createTag: {
    readonly tag: {
      readonly color: Colors;
      readonly createdBy: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly label: string;
      readonly lastChangedBy: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type TagModalCreateTagMutation = {
  response: TagModalCreateTagMutation$data;
  variables: TagModalCreateTagMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTagMutationPayload",
    "kind": "LinkedField",
    "name": "createTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tag",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "lastChangedBy",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TagModalCreateTagMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TagModalCreateTagMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d050d5ae8e9265550833b2220d9fb59a",
    "id": null,
    "metadata": {},
    "name": "TagModalCreateTagMutation",
    "operationKind": "mutation",
    "text": "mutation TagModalCreateTagMutation(\n  $input: CreateTagMutationInput!\n) {\n  createTag(input: $input) {\n    tag {\n      id\n      label\n      color\n      createdBy {\n        id\n      }\n      lastChangedBy {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc1fa065512628be317f613e99406445";

export default node;
